export default function Loading() {
  return (
    <div className="fixed bg-[#00000088] backdrop:blur-lg h-dvh w-dvw flex justify-center items-center z-[101]">
      <div className="w-10 h-10 border-4 border-gray-300 border-t-[var(--primary)] rounded-full animate-spin"></div>
    </div>
  );
}
